import { RowDescriptorOptions } from './row-descriptor-options';

export class RowDescriptor<TData, TId> {
  isDisabled = false;
  isSelected = false;

  get id(): TId {
    return this.getId(this);
  }

  constructor(
    public data: TData,
    private readonly getId: (rowDescriptor: RowDescriptor<TData, TId>) => TId,
    options?: RowDescriptorOptions
  ) {
    if (!options) {
      return;
    }

    if (typeof options.isDisabled !== 'undefined') {
      this.isDisabled = options.isDisabled;
    }

    if (typeof options.isSelected !== 'undefined') {
      this.isSelected = options.isSelected;
    }
  }
}
